import React, { useEffect, useState } from "react";
import './LineaDeTiempo.scss'
import { Timeline } from "primereact/timeline";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import markerIcon from '../../../assets/icons/marker.svg'
import HoverText from "../../atoms/HoverText/HoverText";
import { Slider } from "primereact/slider";
import { Tooltip } from "@mui/material";


const LineaDeTiempo = ({ handleUnidadClick, paradasTotales }) => {
    const [events, setEvents] = useState()
    const [confirmada, setConfirmada] = useState(false)
    const [paradasTomadasTotales, setParadasTomadasTotales] = useState(0)

    
    
    useEffect(() => {
        setEvents(paradasTotales)
        setConfirmada(paradasTotales.CONFIRMADA)
        const lastIndex = paradasTotales.paradasTomadas?.map(item => item.ExisteEnRegistro).lastIndexOf(1);
        setParadasTomadasTotales(lastIndex)

    }, [paradasTotales])

    if (confirmada) {
    }
    const customizedMarker = (item, key) => {
        return (
            <span className={`containerParada ${item.ExisteEnRegistro ? "green" : "red"}`} style={{ borderRadius: "100%" }}>
                <img src={markerIcon} width={20} alt="" />
            </span>
        );



    };
    const custotomerContent = (item, key) => {

        let ultimoEta = []
        let indiceEta = 0
    

        let horarioParadasEta = []
        paradasTotales.paradasTomadas?.map((parada, indice) => {

            if (parada.ETA != null) {
                ultimoEta = JSON.parse(parada.ETA)
                indiceEta = indice
            }
            else {
                ultimoEta = null
            }
        })



        // horaEstimadaArribo

        return (
            <div className="parada">
                        {
                            ultimoEta?.length > 0 || ultimoEta != null ?
                                <>
                                    {
                                        ultimoEta?.map((etaParada, keyParada) => {
                                            <Tooltip title={`Parada:${key + keyParada} - Nombre: ${etaParada.parada} - Hora estimada de arribo: ${etaParada.horaEstimadaArribo}`}>
                                                <div className="nombre">
                                                    {key + keyParada}
                                                </div>
                                            </Tooltip>
                                        })
                                    }
                                </>
                                :
                                <>
                                    {
                                        item.ExisteEnRegistro ?
                                            <>
                                                <Tooltip title={`Parada:${key + 1} - Nombre: ${item?.NOMBRE} - Hora de arribo: ${item?.REGISTRO}`}>
                                                    <div className="nombre">
                                                        {key + 1}
                                                    </div>
                                                </Tooltip>
                                            </> :
                                            <>
                                                <Tooltip title={`Parada:${key + 1} - Nombre: ${item?.NOMBRE} - Hora programada de arribo: ${item?.HORARIO_PARADA}`}>
                                                    <div className="nombre">

                                                        {key + 1}
                                                    </div>
                                                </Tooltip>
                                            </>
                                    }

                                </>
                        }
                 
            </div>
        );
    };

    const handleSliderChange = (e) => {

        const sliderValue = e.value;

        // Aquí puedes hacer alguna acción con el valor del slider, como llamar a handleUnidadClick
        handleUnidadClick(paradasTotales);
    };
    return (
        <div className={`LineaDeTiempo ${confirmada == false ? "bgred" : ""}`}>
            <div className="rutatitle">
                {paradasTotales?.routeName} bitacora {paradasTotales.ID_BITACORA}
            </div>
            <div className="card">
                <Slider onChange={handleSliderChange} className={`${paradasTotales.PROVEEDOR == "SUMA" ? "image-slider" : "image-slider_aliado"}`} value={(paradasTomadasTotales * 100) / paradasTotales?.markers?.length} />
                <Timeline value={events?.paradasTomadas} align="top" layout="horizontal" className="customized-timeline" marker={customizedMarker} content={custotomerContent} />
            </div>
        </div>
    )
}
export default LineaDeTiempo